import ElementModal from './ElementModal';
import ElementModalSheet from './ElementModalSheet';

import { MobileComponentSwitch } from '../../mobile/utils/MobileComponentSwitch';

const ElementModalRoot = MobileComponentSwitch(ElementModal, ElementModalSheet);

export default ElementModalRoot;
